import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ChevronRight } from '@outdoor-voices/ui';
import { memo, useEffect, useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { PUBLISHED } from './constants';
import css from './UGC.module.scss';
import outerWidth from '../../utils/dom/outerWidth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var getProductUrlParams = function getProductUrlParams(faceout) {
  if (faceout && faceout.status === PUBLISHED && faceout.variant.inventoryQuantity > 0) {
    return "?variant=".concat(faceout.variant.shopifyId);
  }

  return '';
};

var Products = function Products(_ref) {
  var enabled = _ref.enabled,
      fixed = _ref.fixed,
      products = _ref.products,
      on = _ref.on,
      setOn = _ref.setOn,
      width = _ref.width;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      lefties = _useState4[0],
      setLefties = _useState4[1];

  var getLeft = function getLeft(xPosition) {
    return "".concat((xPosition * 100).toFixed(2), "%");
  };

  var getTop = function getTop(yPosition) {
    return "".concat((yPosition * 100).toFixed(2), "%");
  };

  useEffect(function () {
    if (!enabled) {
      return;
    }

    if (mounted) {
      return;
    }

    setMounted(true);
    var newLefties = {};
    products.forEach(function (_ref2) {
      var _ref2$node = _ref2.node,
          id = _ref2$node.id,
          xPosition = _ref2$node.xPosition;
      var flag = document.getElementById(id);

      if (xPosition * width + outerWidth(flag) > width) {
        newLefties[id] = true;
      }
    });

    if (newLefties !== {}) {
      setLefties(newLefties);
    }
  }, [enabled, mounted, products, width]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [products.map(function (_ref3, idx) {
      var _ref3$node = _ref3.node,
          id = _ref3$node.id,
          faceout = _ref3$node.faceout,
          xPosition = _ref3$node.xPosition,
          yPosition = _ref3$node.yPosition,
          product = _ref3$node.product;
      return /*#__PURE__*/_jsx("div", {
        className: css.product,
        style: {
          position: fixed ? 'fixed' : 'absolute',
          left: getLeft(xPosition),
          top: getTop(yPosition)
        },
        children: /*#__PURE__*/_jsxs("a", {
          className: cc([css.flag, _defineProperty({}, css.lefty, lefties[id] !== undefined)]),
          href: "".concat(product.absoluteUrl).concat(getProductUrlParams(faceout)),
          id: id,
          style: {
            '--delay': "".concat(idx * 0.1, "s")
          },
          children: [/*#__PURE__*/_jsx("div", {
            children: product.title
          }), /*#__PURE__*/_jsx(ChevronRight, {})]
        })
      }, id);
    }), /*#__PURE__*/_jsx("button", {
      "aria-label": "Click to ".concat(on ? 'hide' : 'display', " products in the image"),
      className: cc([css.toggle, _defineProperty({}, css.on, on)]),
      onClick: function onClick() {
        setOn(!on);
      },
      type: "button",
      children: /*#__PURE__*/_jsxs("svg", {
        "aria-hidden": "true",
        role: "presentation",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        children: [/*#__PURE__*/_jsx("title", {
          children: "Minus/Collapse Icon"
        }), /*#__PURE__*/_jsxs("g", {
          "aria-hidden": "true",
          stroke: "none",
          strokeWidth: "1",
          fill: "currentColor",
          fillRule: "evenodd",
          children: [/*#__PURE__*/_jsx("path", {
            className: css.vertical,
            d: "M14,6 L14,8 L0,8 L0,6 L14,6"
          }), /*#__PURE__*/_jsx("path", {
            className: css.horizontal,
            d: "M14,6 L14,8 L0,8 L0,6 L14,6"
          })]
        })]
      })
    })]
  });
};

Products.propTypes = {
  enabled: PropTypes.bool,
  fixed: PropTypes.bool,
  on: PropTypes.bool,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  setOn: PropTypes.func,
  width: PropTypes.number
};
export default /*#__PURE__*/memo(Products);